import momentTz from 'moment-timezone';

import type { BarryConversationList } from '~api/common/barry/barry';

export const DAILY_MESSAGE_LIMIT = 30;

/**
 * Gets the user's timezone
 */
const getUserTimezone = (): string => {
	return momentTz.tz.guess();
};

/**
 * Checks if a date is today in the user's local timezone
 */
const isToday = (date: Date): boolean => {
	const userTimezone = getUserTimezone();
	const dateInUserTz = momentTz(date).tz(userTimezone);
	const todayInUserTz = momentTz().tz(userTimezone);

	return dateInUserTz.isSame(todayInUserTz, 'day');
};

/**
 * Counts user messages sent today across all conversations
 */
export const getTodaysMessageCount = (
	allConversations: BarryConversationList | null | undefined,
): number => {
	if (!allConversations?.conversations) {
		return 0;
	}

	return allConversations.conversations.reduce((total, conversation) => {
		const updatedDate = new Date(conversation.updatedAt);

		if (isToday(updatedDate)) {
			return total + Math.ceil(conversation.messageCount / 2);
		}

		return total;
	}, 0);
};

/**
 * Checks if user has reached daily message limit
 */
export const hasReachedLimit = (count: number): boolean => {
	return count >= DAILY_MESSAGE_LIMIT;
};

/**
 * Gets remaining messages for today
 */
export const getRemainingMessages = (count: number): number => {
	return Math.max(0, DAILY_MESSAGE_LIMIT - count);
};
